import { CreditType } from "@utilities/types";
import { createContext, FC, PropsWithChildren, useState } from "react";

interface CreditContextType {
    credits: CreditType[]
    setCredits: React.Dispatch<React.SetStateAction<CreditType[]>>
    closedCredits: CreditType[]
    setClosedCredits: React.Dispatch<React.SetStateAction<CreditType[]>>
}

export const CreditContext = createContext<CreditContextType>({
    credits: [],
    setCredits: () => { },
    closedCredits: [],
    setClosedCredits: () => { },
})

export const CreditsContextProvider: FC<PropsWithChildren> = ({ children }) => {

    const [credits, setCredits] = useState<CreditType[]>([]);
    const [closedCredits, setClosedCredits] = useState<CreditType[]>([]);

    return (
        <CreditContext.Provider value={{
            credits, setCredits,
            closedCredits, setClosedCredits,
        }}>
            {children}
        </CreditContext.Provider>
    )
}
